import Ajax from "./ajax";

export default class DeleteFormModal {
    /**
     * 
     * @param {string} options.title
     * @param {string} options.text
     * @param {string} options.url
     * @param {string} options.data
     * @param {string} options.onSuccess
     */
    constructor(options) {
        options.data = options.data || {};
        let myself = this;
        this.dialog = bootbox.dialog({
            title: options.title,
            message: options.text,
            buttons: {
                cancel: {
                    label: 'Cancelar',
                    className: 'btn-danger'
                },
                ok: {
                    label: 'Eliminar',
                    className: 'btn-warning',
                    callback: function() {
                        Ajax.delete(options.url, options.data, {
                            then: function(response) {
                                if (options.onSuccess !== undefined) {
                                    options.onSuccess(response);
                                }
                                myself.dialog.modal('hide');
                            }
                        });
                        return false;
                    }
                }
            }
        });
    }
}